import React, { useEffect, useState } from 'react';
import { format, startOfToday } from 'date-fns';
import DatePicker from '../DatePicker';
import {
  getServiceSchedule,
  getServiceDailySchedule,
  getListAddon
} from '../../API/ServiceAPI';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const ScheduleDialog = ({ venueId, scheduleAddon, onClose }) => {
  const [selectedDate, setSelectedDate] = useState(startOfToday());
  const [schedule, setSchedule] = useState([]);

  const onDaySelected = (day) => {
    setSelectedDate(day);
  };

  const isExistSchedule = (item) => {
    const formattedDate = format(selectedDate, 'yyyy-MM-dd');
    const [startTime, endTime] = item.hour.split(' - ');
    console.log(formattedDate)
    console.log(startTime, endTime)
    return scheduleAddon.some(
      (entry) =>
        entry.date_available === formattedDate &&
        entry.start_time === startTime &&
        entry.end_time === endTime
    );
  };

  function updateAvailability(times) {
    var tmpTimes = [...times];
    const currentDate = new Date();
    // console.log("selectedDate", selectedDate);
    // console.log("currentDate", currentDate);
    if (format(selectedDate, 'yyyy-MM-dd') === format(currentDate, 'yyyy-MM-dd')) {
      const currentHour = currentDate.getHours();
      tmpTimes.forEach((item, index) => {
        const slotHour = parseInt(item.hour.split(":")[0]);
        // console.log("available", slotHour >= currentHour);
        if (slotHour <= currentHour) {
          tmpTimes[index].available = false;
        }
      });
    }
    // console.log(tmpTimes);
    return times;
  }

  useEffect(() => {
      getServiceDailySchedule(
        venueId,
        selectedDate,
        (responseJSON) => {
          setSchedule(updateAvailability(responseJSON.times))
          console.log("setSchedule(updateAvailability(responseJSON.times))", scheduleAddon)
        },
        (messages) => console.debug("FAIL", messages)
      )
    }, [selectedDate]);

  const renderSchedule = () => {
    return (
      <div className="flex flex-col px-1 grid grid-cols-2 gap-4 lg:grid-cols-3">
        {schedule.map((item, index) => (
          <div
            key={index}
            className={
              isExistSchedule(item)
                ? 'flex items-center justify-between w-full border border-primaryRed text-sm rounded-lg pl-4 pt-4 pb-4 pr-2 bg-white'
                : 'flex items-center justify-between w-full border text-gray-400 text-sm rounded-lg pl-4 pt-4 pb-4 pr-2 bg-gray-200'
            }
          >
            <p className="font-medium">{item.hour}</p>


            {isExistSchedule(item)&&(<CheckCircleIcon className='w-6 text-gray-300 ml-2' />)}
          </div>
        ))}
      </div>
    );
  };

  if (scheduleAddon.length === 0) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-auto">
  <div className="relative w-full max-w-[900px] mx-4 my-4 bg-white rounded-2xl flex flex-col max-h-[90vh] overflow-y-auto">
    {/* Close button top-right */}
    

    <div className="w-full flex gap-x-4 py-4 px-4 rounded-lg bg-white">
      <div className='md:flex md:gap-6 w-full'>
        <div className='md:w-2/5 mb-4 md:mb-0 flex flex-col'>
            <div className="flex mr-2 mb-2">
              <p className="text-right font-bold m-2">Pilih Tanggal</p>
            </div>
          <DatePicker onDaySelected={onDaySelected} />
        </div>

        <div className='md:w-3/5 flex flex-col'>
          <div className="flex flex-row">
            <div className="flex flex-1 mr-2 mb-2">
              <p className="text-right font-bold m-2">Jadwal Ketersediaan</p>
            </div>
            <button
      onClick={onClose}
      className="absolute top-4 right-6 text-gray-500 hover:text-primaryRed transition text-xl font-bold"
    >
      ✕
    </button>
          </div>
          {renderSchedule()}
        </div>
      </div>
    </div>

    <div className="w-full flex justify-end p-4">
      {/* Optional footer buttons */}
    </div>
  </div>
</div>


  );
};

export default ScheduleDialog;
